import {Component} from '@angular/core';
import {User} from '../../models/beans';
import {LoginService} from './login.service';
import {AppComponent} from '../app.component';
declare var jQuery: any;

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent {

    user: User = new User();
    
    constructor(public loginService: LoginService) {}

    
    login() {
        this.loginService.login(this.user);
    }

}
